import { useState, useCallback, useEffect } from "react";
import { safeGetItem, safeSetItem, safeRemoveItem } from "../../../utils/storage";

const IGNORE_LOCATION_PERMISSION_KEY = 'ignoreLocationPermission';

export const useIgnoreLocationPermission = () => {
  const [isIgnored, setIsIgnored] = useState<boolean>(() => {
    return safeGetItem(IGNORE_LOCATION_PERMISSION_KEY) === 'true';
  });

  // Listen for localStorage changes from other tabs/windows
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === IGNORE_LOCATION_PERMISSION_KEY) {
        setIsIgnored(e.newValue === 'true');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const setIgnoreLocationPermission = useCallback(() => {
    safeSetItem(IGNORE_LOCATION_PERMISSION_KEY, 'true');
    setIsIgnored(true);
  }, []);

  const clearIgnoreLocationPermission = useCallback(() => {
    safeRemoveItem(IGNORE_LOCATION_PERMISSION_KEY);
    setIsIgnored(false);
  }, []);

  return {
    isIgnored,
    setIgnoreLocationPermission,
    clearIgnoreLocationPermission,
  };
};